/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 捷克语
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">To inform you when your pre-order is in our store, and to verify your pre-order at pick-up, Xiaomi will collect <strong>your name and email address,</strong>and the pick-up code will be sent to this email address.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">The legal basis for these activities of processing your personal data is their <strong>necessity for performing a contract to which you are a party.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may exercise your data protection rights (e.g., access, rectification and/or erasure) through our Privacy Support Platform (<a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff"> https://privacy.mi.com/support/</span></a>) for more information on how we process your personal data.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Please refer to our Privacy Policy (<a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>) for more information on how we process your personal data.</span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)